export function initLanguageSwitcher(): void {
    const switchers = document.querySelectorAll<HTMLElement>('.language-switcher');
    switchers.forEach((switcher) => {
        const alternativeLanguageUrl = switcher.dataset.alternativeLanguageUrl;
        if (!alternativeLanguageUrl) return;

        const radios = switcher.querySelectorAll<HTMLInputElement>('.language-switcher__radio');
        radios.forEach((radio) => {
            radio.addEventListener('change', () => {
                window.location.assign(alternativeLanguageUrl);
            });
        });
    });
}
